import './Products.css';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import paddy1 from '../assets/Links/Paddy_1.png';
import paddy2 from '../assets/Links/Paddy_2.png';
import paddy3 from '../assets/Links/Paddy_3.png';
import product3 from '../assets/Links/Rice_Bags_Group_1.png';
import product2 from '../assets/Links/Rice_Bags_Group_2.png';
import product1 from '../assets/Links/Rice_Bags_Group_3.png';
import riceBags from '../assets/Links/Main_Rice_bag.png';
import ScrollArrow from '../components/ScrollArrow';
import React, {useState,useEffect} from 'react';
import BackToTop from '../components/BackToTop';


const Products = () => {
    const [showArrow, setShowArrow] = useState(true);
    const extraOffset = 50; // pixels to move further down
  
    useEffect(() => {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        setShowArrow(scrollY < 50); // show only at top
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
      const scrollToNextSection = () => {
      window.scrollTo({
        top: window.innerHeight+ extraOffset,
        behavior: "smooth",
      });
    };
  return (
    <div className="page-wrapper-products">
      <div className="products-hero-banner">
          <NavBar />
          <div className='products-banner-image'>
          <img src={riceBags} alt="Rice Bags" className="rice-bags-image" />
          </div>
        </div>
      <div className="products-wrapper">
        <div className="products product1">
          <div className="product-image product1">
            <img src={product1} alt="Product 1" />
            <p>Available in 5kg, 10kg, 26kg packs</p>
            </div>
            <div className="product-text product1-text">
              <h2 className="accent-heading">Mr. Butler</h2>
              <h3 className="primary-heading">Special Rajabogam</h3>
              <h4>Premium-Aged Rice | Traditional Taste | Mother's Choice</h4><br/>
              <p><strong>Aged to Perfection. Steeped in Heritage.</strong></p>
              <p>Step into tradition with <strong>Mr. Butler’s Special Rajabogam Rice</strong> — an expertly aged rice that brings home the authentic flavor of South Indian cooking. Naturally matured for enhanced aroma and fluffiness, this rice is the go-to choice for mothers who never compromise on quality.</p>
              <p>Specially selected and aged under controlled conditions, Rajabogam Old Rice gives you the perfect texture for biryanis, sambars, and traditional festival meals. It absorbs flavors beautifully and remains non-sticky, making every dish rich, flavorful, and full of heritage.</p>
              <h4>Why You'll Love It</h4>
              <ul>
                <li>Expertly Aged – Naturally matured for deep flavor and aroma</li>
                <li>Traditional Texture – Soft, fluffy, and never sticky</li>
                <li>Authentic Taste – Brings depth to biryanis, sambars, and festive dishes</li>
                <li>Premium Selection – Uniform, stone-free, and high in quality</li>
                <li>Perfect for Biryani, Variety Rice, Meals with Kulambu, and Festival Cooking</li>
              </ul>
              <p>Whether it’s a temple-style feast or a homely Sunday lunch, <strong>Mr. Butler Special Rajabogam</strong> gives you the same comforting flavor every time — just like how it’s always been in your childhood kitchen.</p>
              </div>
              <div className="paddy-image paddy1">
            <img src={paddy1} alt="Paddy 1" />
            </div>
        </div>
        <div className="products product2">
            <div className="paddy-image paddy2">
            <img src={paddy2} alt="Paddy 2" />
            </div>
            <div className="product-text product2-text">
              <h2 className="accent-heading">Mr. Butler</h2>
              <h3 className="primary-heading">Nei Kitchdi</h3>
              <h4>Long Grain | Lingering Aroma | Sweet Taste | Premium Quality</h4><br/>
              <p><strong>Crafted for Comfort. Made for Flavor.</strong></p>
              <p>Introducing  <strong>Mr. Butler’s Nei Kitchdi Rice</strong> – a specialty rice that turns every simple meal into a soulful experience. With long, slender grains, a gentle lingering aroma, and a naturally sweet finish, this rice is perfect for ghee-rich kichadi, pongal, and other comforting South Indian dishes.</p>
                        <p>Sourced from select farms and milled with precision, this rice absorbs ghee and spices beautifully while maintaining a soft, fluffy texture. It’s everything a traditional kichadi rice should be — light, fragrant, and full of homely goodness.</p>
              <h4>Why You'll Love It</h4>
              <ul>
                <li>Long Grain Texture – Cooks soft yet holds shape</li>
                <li>Mild & Lingering Aroma – Brings your kitchen to life</li>
                <li>Naturally Sweet Taste – Enhances every spoonful</li>
                <li>Premium Quality Grains – Stone-free, polished, and uniform</li>
                <li>Perfect for Kichadi, Pongal, Sakkarai Pongal & Light Meals</li>
              </ul>
              <p>Whether it’s a weekday meal or a festival breakfast, <strong>Mr. Butler Nei Kitchdi Rice</strong> is the rice you can trust — for purity, taste, and the touch of tradition.</p>
              </div>
              <div className="product-image product2">
            <img src={product2} alt="Product 2" />
            <p>Available in 5kg, 10kg, 26kg packs</p>
            </div>
        </div>
        <div className="products product3">
          <div className="product-image product3">
            <img src={product3} alt="Product 3" />
            <p>Available in 5kg, 10kg, 26kg packs</p>
            </div>
            <div className="product-text product3-text">
              <h2 className="accent-heading">Mr. Butler</h2>
              <h3 className="primary-heading">Kolam Ponni Rice</h3>
              <h4>Medium Grain | Soft Texture | Subtle Aroma | Everyday Premium</h4><br/>
              <p><strong>Light on the Plate. Rich in Tradition.</strong></p>
              <p>Introducing <strong>Mr. Butler Kolam Ponni Rice</strong> – a beloved South Indian staple known for its soft, fluffy texture and gentle aroma. Perfect for everyday meals, this rice blends seamlessly with curries, sambar, rasam, or even a dollop of curd, making every plate feel like home.</p>
                        <p>Carefully cultivated in fertile fields and milled to perfection, our Kolam Ponni Rice is light on the stomach, yet satisfying to the soul. Whether served fresh or as part of a next-day meal, it retains its softness and taste — just the way tradition intended.</p>
              <h4>Why You'll Love It</h4>
              <ul>
                <li>Medium-Grain Goodness – Soft, fluffy, and wholesome</li>
                <li>Subtle Aroma – Enhances without overpowering</li>
                <li>Versatile Pairing – Ideal for sambar, rasam, curd rice & more</li>
                <li>Consistent Quality – Uniform, stone-free, and neatly polished</li>
                <li>Perfect for Everyday Cooking – Light, digestible, and satisfying</li>
              </ul>
              <p>From weekday lunches to weekend family feasts, <strong>Mr. Butler Kolam Ponni Rice</strong> brings purity, quality, and the comforting taste of home to your table.</p>
              </div>
              <div className="paddy-image paddy3">
            <img src={paddy3} alt="Paddy 3" />
            </div>
        </div>
      </div>
      {showArrow && (
        <ScrollArrow onClick={scrollToNextSection} /> )}
        <BackToTop />
      <Footer />
    </div>
  );
};

export default Products;